import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { UtagHelperService } from '../utag-helper.service';
import { DEV_API_KEY, DEV_API_URL, QAS_API_KEY, QAS_API_URL } from '../../../../environments/apiConfig';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpPrepareCallService {
  hookUrl!: string;
  defaultLanguage!: string;
  sessionType!: string;
  activeLanguageChanged: EventEmitter<any> = new EventEmitter<any>();
  environment!: string;
  apiUrl: string;
  apiKey: string;
  customer_role!: string;
  customer_subrole!: string;
  site_language: any;

  public constructor(
    protected readonly httpClient: HttpClient,
    protected utagHelperService: UtagHelperService,
  ) {
    this.setSiteLanguageFromUtag();
    const body = document.getElementsByTagName('body')[0];
    const env = body.getAttribute('data-cs-env');

    this.environment = env ?? 'prod';
    switch (this.environment) {
      case 'dev': {
        this.apiUrl = DEV_API_URL;
        this.apiKey = DEV_API_KEY;
        break;
      }
      case 'qa': {
        this.apiUrl = QAS_API_URL;
        this.apiKey = QAS_API_KEY;
        break;
      }
      default: {
        // on prod or local development (this.environment  === undefined)
        // will read it from the environment.*.ts file set on build
        this.apiUrl = environment.apiRootUrl;
        this.apiKey = environment.apiKey;
        break;
      }
    }
  }

  private setSiteLanguageFromUtag() {
    this.site_language = this.utagHelperService.getLanguage();
  }
}
